import { Grid, Typography, makeStyles } from '@paintscout/ui'
import type { MuiTheme as Theme } from '@paintscout/ui'
import React from 'react'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    marginTop: theme.spacing(1),
    paddingRight: theme.spacing(4)
  },
  label: {
    color: theme.paintscout.palette.brand.Neutral.P70
  }
}))

interface TotalItemProps {
  label: string
  value?: string | number
}

export function TotalItem({ label, value }: TotalItemProps) {
  const classes = useStyles()
  return (
    <Grid className={classes.root} container direction="row" justifyContent="space-between" alignItems="center">
      <Grid item>
        <Typography variant={'overline'} classes={{ root: classes.label }}>
          {label}
        </Typography>
      </Grid>
      {value && (
        <Grid item>
          {typeof value === 'string' ? (
            <Typography variant={'body1'}>{value}</Typography>
          ) : (
            <Typography variant={'body1'} value={value} format={'price'} />
          )}
        </Grid>
      )}
    </Grid>
  )
}
